export default __webpack_public_path__ + "static/media/home-section-05.eeb26b51.png";